<template>
  <div>
    <codemirror :value="code" :options="ceOptions" @blur="saveCode" @input="onCmCodeChange"></codemirror>
  </div>
</template>

<script>
import {codemirror} from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/dracula.css'
import 'codemirror/mode/xml/xml.js'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/css/css.js'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import Utils from "../services/Utils";

export default {
  name: "CodeEditorComponent",
  props: {
    code: String,
    pageId: String,
    mode: String
  },
  components: {
    codemirror
  },
  data() {
    return {
      ceCode: this.code,
      ceOptions: {
        tabSize: 4,
        mode: this.mode,
        theme: 'dracula',
        lineNumbers: true,
        line: true,
      }
    }
  },
  mounted() {

  },
  watch: {},
  methods: {
    onCmCodeChange(newCode) {
      this.ceCode = newCode;
    },
    saveCode() {
      if (!this.$store.getters.can('edit_splash_pages')) {
        this.$root.$emit("alert_error", ['Not allowed to edit splash page']);
        return;
      }
      this.errors = [];
      let params = null;
      if (this.mode === "text/html")
        params = {html: this.ceCode};
      if (this.mode === "text/css")
        params = {css: this.ceCode};
      if (this.mode === "text/javascript")
        params = {custom_scripts: this.ceCode};

      let request = this.axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/splash_pages/' + this.pageId, params)
      request.then(() => {
        this.$root.$emit("refresh_page", true);
      }).catch((error) => {
        if (error.response != null && error.response.status === 422)
          this.errors = Utils.processError(error.response.data);
        else
          this.errors.push("An error occurred while connecting to server")
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped>
.CodeMirror {
  height: auto !important;
}
</style>